import { useCallback, useEffect, useState, useRef } from "react";
import { initialPaging } from "../Constants/paging";
import {
  CallApiGetHistory,
  CallApiGetMisaInvoiceView,
  CallApiGetSepayEventById,
  CallApiCreateManualInvoice,
} from "../Api/Enforcement";
import { SwalError, SwalFail, SwalSuccess } from "../Share/Swal";

export const useHistoryPage = () => {
  const [histories, setHistories] = useState([]);
  const [paging, setPaging] = useState(initialPaging);
  const pagingRef = useRef(paging);
  const [type, setType] = useState({ value: "", label: "" });
  const [search, setSearch] = useState("");
  const [viewingId, setViewingId] = useState(null);
  const viewingIdRef = useRef(null);
  const [creatingId, setCreatingId] = useState(null);
  const creatingIdRef = useRef(null);
  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);
  const [invoiceHistory, setInvoiceHistory] = useState(null);
  const [sepayEvent, setSepayEvent] = useState(null);
  const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);
  const isCreatingInvoiceRef = useRef(false);

  useEffect(() => {
    pagingRef.current = paging;
  }, [paging]);

  const getListHistories = useCallback(
    (pageNum) => {
      const data = {
        type: type.value,
        searchText: search,
        page: pageNum !== undefined ? pageNum : pagingRef.current.pageIndex,
      };

      CallApiGetHistory(data, (res) => {
        if (res.Status === "success") {
          var data = res.Response.data;
          setHistories(data.Items);
          setPaging((prev) => ({
            ...prev,
            next: data.Next,
            previous: data.Previous,
            totalPages: data.TotalPagesCount,
            pageIndex: data.PageIndex,
          }));
        }
      });
    },
    [type, search]
  );

  useEffect(() => {
    getListHistories();
  }, [getListHistories]);

  const handleSelectType = useCallback((type) => {
    setType(type);
    setPaging((prev) => ({ ...prev, pageIndex: 0 }));
  }, []);

  const handleViewInvoice = useCallback((row) => {
    if (!row?.Id || viewingIdRef.current != null) return;

    viewingIdRef.current = row.Id;
    setViewingId(row.Id);
    const tab = window.open("", "_blank");

    CallApiGetMisaInvoiceView(row.Id, (res) => {
      viewingIdRef.current = null;
      setViewingId(null);

      if (res.Status === "success") {
        const url = res.Response?.data?.Data;
        if (url) {
          if (tab) {
            tab.location.href = url;
          } else {
            window.open(url, "_blank");
          }
          return;
        }
      }

      if (tab) tab.close();

      const error = res.Response;
      if (error?.status === 400) {
        SwalFail(error.data?.Message || "Không lấy được link hóa đơn!");
      } else {
        SwalError(
          "Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ"
        );
      }
    });
  }, []);

  const handleCloseCreateInvoiceModal = useCallback(() => {
    setShowCreateInvoiceModal(false);
    setInvoiceHistory(null);
    setSepayEvent(null);
    setIsCreatingInvoice(false);
    isCreatingInvoiceRef.current = false;
  }, []);

  const handleOpenCreateInvoice = useCallback((row) => {
    if (!row?.SepayEventId || creatingIdRef.current != null) return;

    creatingIdRef.current = row.Id;
    setCreatingId(row.Id);

    CallApiGetSepayEventById(row.SepayEventId, (res) => {
      creatingIdRef.current = null;
      setCreatingId(null);

      if (res.Status === "success") {
        setInvoiceHistory(row);
        setSepayEvent(res.Response.data);
        setShowCreateInvoiceModal(true);
        return;
      }

      const error = res.Response;
      if (error?.status === 400) {
        SwalFail(error.data?.Message || "Không tìm thấy giao dịch Sepay");
      } else {
        SwalError(
          "Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ"
        );
      }
    });
  }, []);

  const handleCreateInvoice = useCallback(() => {
    if (isCreatingInvoiceRef.current || !invoiceHistory || !sepayEvent) return;

    isCreatingInvoiceRef.current = true;
    setIsCreatingInvoice(true);
    CallApiCreateManualInvoice(
      {
        HistoryAdminId: invoiceHistory.Id,
        SepayEventId: Number(invoiceHistory.SepayEventId),
        Amount: sepayEvent.transfer_amount,
      },
      (res) => {
        isCreatingInvoiceRef.current = false;
        setIsCreatingInvoice(false);

        if (res?.success) {
          SwalSuccess("Tạo hóa đơn thành công!");
          handleCloseCreateInvoiceModal();
          getListHistories();
          return;
        }

        const error = res.Status;
        if (error?.status === 400) {
          SwalFail(error.data?.Message || "Tạo hóa đơn thất bại!");
        } else {
          SwalError(
            "Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ"
          );
        }
      }
    );
  }, [invoiceHistory, sepayEvent, handleCloseCreateInvoiceModal, getListHistories]);

  return {
    histories,
    search,
    type,
    paging,
    viewingId,
    creatingId,
    showCreateInvoiceModal,
    invoiceHistory,
    sepayEvent,
    isCreatingInvoice,
    getListHistories,
    setSearch,
    handleSelectType,
    handleViewInvoice,
    handleOpenCreateInvoice,
    handleCloseCreateInvoiceModal,
    handleCreateInvoice,
  };
};
